let popstateListenerWasAdded = false;
let prevPageContent = '';

export const ALAN_BTN_PAGE_SYNC_EVENT = 'alan-btn__page-sync';

export function manageSyncPageStateListeners(isEnabled) {
    if (isEnabled) {
        if (popstateListenerWasAdded !== true) {
            popstateListenerWasAdded = true;
            window.addEventListener(ALAN_BTN_PAGE_SYNC_EVENT, listenForPageChanges);
        }
    } else {
        popstateListenerWasAdded = false;
        window.removeEventListener(ALAN_BTN_PAGE_SYNC_EVENT, listenForPageChanges);
    }
}

export function syncPageState(onSendCb?) {
    sendPageState(onSendCb);
}

function listenForPageChanges() {
    sendPageState();
}

function sendPageState(onSendCb?) {
    var page = document.createElement('html');
    page.innerHTML = document.getElementsByTagName('html')[0].innerHTML;

    var scripts = page.getElementsByTagName('script') as unknown as HTMLScriptElement[];
    var styles = page.getElementsByTagName('style') as unknown as HTMLScriptElement[];
    var alanBtnEl = page.getElementsByClassName('alanBtn-root') as unknown as HTMLDivElement[];
    var debugChatEl = page.getElementsByClassName('alanStudio-debug-chat') as unknown as HTMLDivElement[];
    var elementsToRemove = [...scripts, ...styles, ...alanBtnEl, ...debugChatEl];

    for (var i = 0; i < elementsToRemove.length; i++) {
        elementsToRemove[i].remove();
    }

    const pageContent = page.outerHTML;

    if (onSendCb) {
        onSendCb();
    }

    if (prevPageContent === pageContent) {
        return;
    }

    prevPageContent = pageContent;

    if (window.tutorProject) {
        window.tutorProject.call('syncPageState', {
            html: pageContent,
            url: window.location.href
        });
    }
}